/**
 * Inserts an element after target element (inserts a sibling)
 * @param {Element} target
 * @param {Element | Node} element
 */
export const insertAfter = (target, element) => {
  target.parentNode.insertBefore(element, target.nextSibling);
};
